export default function GlobalHandlers ()
{
  const pThis = this;

  const domHandlers = {};

  const addRemoveGlobalHandler = (isAddHandler, element, eventName, handler, handlerName, args = {}) =>
  {
    let allFrames,
        iFrame,
        excludeWindows = args.excludeWindows || {},
        excludeWindowPartName = args.excludeWindowPartName || null;

    if (BEditor.environment.isTopWindow)
    {
      if (isAddHandler)
      {
        this.removeDomHandler(window, handlerName);
        this.addDomHandler(window, element, eventName, handler, handlerName, args);
      }
      else
      {
        this.removeDomHandler(window, handlerName);
      }

      allFrames = document.getElementsByTagName('IFRAME');

      for (let i = 0, len = allFrames.length; i < len; i++)
      {
        try
        {
          if (allFrames[i].src.toLowerCase().indexOf(BEditor.environment.getLocationDomain()) === 0)
          {
            iFrame = (BEditor.browser.isIE) ? allFrames[i].contentWindow : allFrames[i].contentDocument.defaultView;

            if (!iFrame.name)
            {
              BEditor.window.setAutoWindowName(iFrame);
            }

            if (isAddHandler && !excludeWindows[iFrame.name] && (excludeWindowPartName === null || iFrame.name.indexOf(excludeWindowPartName) === -1))
            {
              this.removeDomHandler(iFrame, handlerName);
              this.addDomHandler(iFrame, element, eventName, handler, handlerName, args);
            }
            else
            {
              this.removeDomHandler(iFrame, handlerName);
            }
          }
        }
        catch (err) {}
      }
    }
    else
    {
      //TODO:Dime
    }
  };


  this.addGlobalHandler = (element, eventName, handler, handlerName, args) =>
  {
    addRemoveGlobalHandler(true, element, eventName, handler, handlerName, args);
  };


  this.removeGlobalHandler = (handlerName) =>
  {
    addRemoveGlobalHandler(false, null, null, null, handlerName);
  };


  this.addGlobalMouseDown = (handler, handlerId) =>
  {
    BEditor.globalHandlers.addGlobalHandler(((BEditor.browser.isIE && BEditor.browser.isIE < 9) ? 'document' : 'window'), 'mousedown', handler, handlerId, {});
  };


  this.addDomHandler = (win, elem, eventName, handler, handlerName, args = {}) =>
  {
    let element,
        winName = win.name;

    if (typeof(elem) === 'string')
    {
      if (elem === 'window')
      {
        element = win;
      }
      else if (elem === 'document')
      {
        element = win.document;
      }
      else if (elem === 'body')
      {
        element = win.document.body;
      }
      else
      {
        element = win.document.getElementById(elem);
      }

      if (element)
      {
        if (!domHandlers[winName])
        {
          domHandlers[winName] = {};
        }

        domHandlers[winName][handlerName] =
        {
          'win': win,
          'element': element,
          'eventName' : eventName,
          'handler' : handler,
          'handlerName' : handlerName,
          'args' : args
        };

        domHandlers[winName][handlerName].object = new LocalDomHandler(domHandlers[winName][handlerName]);
      }
    }

    function LocalDomHandler (domHandler)
    {
      this.removeDomHandler = function () { BEditor.domHandlers.removeHandler(domHandler.element, domHandler.eventName, localHandler); };
      BEditor.domHandlers.addHandler(domHandler.element, domHandler.eventName, localHandler);

      function localHandler (e)
      {
        if (!e && window.event)
        {
          e = window.event;
        }

        if (domHandler.handler != null)
        {
          domHandler.handler(e, domHandler.win, domHandler.args);
        }
      }
    }
  };


  this.removeDomHandler = (win, handlerName) =>
  {
    let winName = win.name;

    if (domHandlers[winName] && domHandlers[winName][handlerName])
    {
      domHandlers[winName][handlerName].object.removeDomHandler();
      delete domHandlers[winName][handlerName].object;
      domHandlers[winName][handlerName].object = null;
      domHandlers[winName][handlerName].element = null;
      domHandlers[winName][handlerName].handler = null;
      domHandlers[winName][handlerName].args = null;
      domHandlers[winName][handlerName] = null;
      delete domHandlers[winName][handlerName];
    }
  };
}